export const form = {
  formId: "mcp-trigger-form",
  formField: {
    endpointUrl: {
      name: "endpointUrl",
      label: "Endpoint URL",
      type: "readonlyEndpoint",
      placeholder: "",
      errorMsg: "",
    },
    triggerName: {
      name: "triggerName",
      label: "Trigger Name",
      type: "text",
      placeholder: "Enter a name for this trigger",
      errorMsg: "Trigger name is required",
      helperText: "A human-friendly name. Will be prefixed with a UUID by the executor.",
    },
    description: {
      name: "description",
      label: "Trigger Description",
      type: "text",
      placeholder: "Describe what this trigger does",
      errorMsg: "Description is required",
      helperText: "Explain the purpose of this trigger.",
      multiline: true,
      rows: 3,
    },
    parameters: {
      name: "parameters",
      label: "Input Parameters",
      type: "array",
      minItems: 0,
      errorMsg: "",
      itemField: {
        paramName: {
          name: "paramName",
          label: "Parameter Name",
          type: "text",
          placeholder: "e.g. userId",
          errorMsg: "Parameter name is required and must be a valid JS object key",
          helperText: "Valid JavaScript object key.",
        },
        paramType: {
          name: "paramType",
          label: "Parameter Type",
          type: "select",
          placeholder: "Select type",
          errorMsg: "Parameter type is required",
          options: [
            { label: "String", value: "string" },
            { label: "Number", value: "number" },
            { label: "Boolean", value: "boolean" },
            { label: "Object", value: "object" },
            { label: "Array", value: "array" },
            { label: "Datetime", value: "datetime" },
          ],
          helperText: "Choose the parameter data type.",
        },
        paramDescription: {
          name: "paramDescription",
          label: "Parameter Description (optional)",
          type: "text",
          placeholder: "Describe this parameter",
          errorMsg: "",
          helperText: "Optional. Will be used as a zod description.",
          multiline: true,
          rows: 2,
        },
      },
    },
    notes: {
      name: "notes",
      label: "Notes",
      type: "text",
      placeholder: "",
      errorMsg: "",
      helperText: "",
      multiline: true,
      rows: 3,
    },
  },
};